'use client';

import type { CSSProperties } from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * Hookshot IDE–style toast host (Sonner).
 * Keep visual tokens aligned with `--toast-radius` in globals.css.
 */
export function AppToaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="bottom-right"
      offset={{ top: 60 }}
      style={{ '--border-radius': 'var(--toast-radius)' } as CSSProperties}
      toastOptions={{
        classNames: {
          toast:
            'group toast rounded-[var(--toast-radius)] group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border/60',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:rounded-lg group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:rounded-lg group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
}
